import config from '../common/config';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { fromJS } from 'immutable';
import { connect } from 'react-redux';
import { Grid, Cell } from 'react-flexr';

import ProductCategory from '../common/product-category';
import { SearchPanel, SearchGroup, Slider } from '../common/search';
import TagFilter from '../common/tagFilter';
import Showcase from '../common/showcase';

function fixValue(value) {
  if(value === undefined || value === null) {
    return '-';
  } else if(value === 0) {
    return 'Ubegrænset';
  }
  return value;
}

const UNLIMITED_DOWNLOAD = 5;
const UNLIMITED_STREAMING = 5;
@connect(({ streaming: { offers } }) => ({ offers }))
@withRouter
class Offers extends ProductCategory {
  constructor(props) {
    super(props);

    this.state = this.mapPropsToState(props, {
      offerType: 'streaming',
      ...this.state,
      defaultFilters: { // FOR FILTERS_USED EPI
        tags: []
      },
      filters: {
        tags: [],
        ...(this.state.filters || {})
      }
    });
  }

  resetFilter() {
    const filters = {
      ...(this.state.filters || {}),
      tags: []
    };
    
    this.setState({
      filters,
      filter: this.createFilter(filters)
    });
  }

  serialiseOffer(offer) {
    const tags = offer.get('tags') ? offer.get('tags').toJS() : [];
    const manualTags = offer.get('manualTags') ? Array.from(offer.get('manualTags')) : [];
    const mergedTags = tags.reduce((acc, tag) => {
      if(!acc.includes(tag)) {
        acc.push(tag);
      }
      return acc;
    }, manualTags || []).filter(Boolean);
    const streamingType = offer.get('streamingType');

    const result = fromJS({
      id: offer.get('_id'),

      provider: offer.get('provider'),
      product: offer.get('product'),
      logo:
        offer.getIn(['image', 'hash']) &&
        `${config.images}${offer.getIn(['image', 'hash'])}`,
      link: `/redirect/${offer.get('uuid')}`,
      tagline: offer.get('tagline'),
      orderText: 'Bestil her',

      details: [
        streamingType === 'tv' ? {
            value: fixValue(offer.get('maxStreamingDevices')),
            unit: '',
            label: 'Max streaming enheder'
        }: null,
        streamingType === 'tv' ? {
          value: fixValue(offer.get('maxDownloadDevices')),
          unit: '',
          label: 'Max downloading enheder'
        }: null,
        streamingType === 'music' ? {
          value: fixValue(offer.get('accounts')),
          unit: '',
          label: 'Max antal brugere'
        }: null,
        streamingType === 'music' ? {
          value: fixValue(offer.get('hoursMonthly')),
          unit: 'timer',
          label: 'Per måned'
        }: null,
        streamingType === 'soundbook' ? {
          value: fixValue(offer.get('hoursMonthly')),
          unit: 'timer',
          label: 'Per måned'
        }: null,
        {
          value: fixValue(offer.get('trialPeriodDays')),
          unit: 'dage',
          label: 'Prøveperiode'
        }
      ].filter(Boolean),

      price: {
        value: offer.getIn(['price', 'monthly']) || '-',
        unit: 'kr.',
        label: 'Per måned'
      },

      usps: []
        .concat(mergedTags, offer.get('services').toJS())
        .filter(Boolean),

      productDescription: offer.get('productDescription'),
      discountCode: offer.get('discountCode'),
      tags: tags.map((v) => typeof v === 'string' ? v.trim(): '').filter(Boolean),

      _raw: offer
    });

    return result;
  }

  createFilter(filters) {
    this.updateFiltersUsed(filters);
    return offers =>
      offers.filter(offer => {
        const tags = Array.from(offer.get('usps'));
        const services = Array.from(offer.getIn(['_raw', 'services']));
        const filteredTags = filters.tags;
        
        const lowerCaseTags = tags.map(i => i.toLowerCase());
        const lowerCaseServices = services.map(i => i.toLowerCase());
        const lowerCaseProvider = offer.get('provider').toLowerCase().trim().replace('-', ' ');

        for (let idx = 0; idx < filteredTags.length; idx++) {
          const tag = filteredTags[idx];
          if (
            !lowerCaseServices.includes(tag) &&
            !lowerCaseTags.includes(tag) && 
            !tags.includes(tag) &&
            !services.includes(tag) &&
            tag.toLowerCase() !== lowerCaseProvider) {
            return false;
          }
        }

        if(filters.streaming && filters.streaming !== UNLIMITED_STREAMING) {
          if(offer.getIn(['_raw', 'maxStreamingDevices']) === 0) {
          } else if(offer.getIn(['_raw', 'maxStreamingDevices']) > 0 && offer.getIn(['_raw', 'maxStreamingDevices']) < filters.streaming) {
            return false;
          }
        }

        if(filters.download && filters.download !== UNLIMITED_DOWNLOAD) {
          if(offer.getIn(['_raw', 'maxDownloadDevices']) === 0) {
          } else if(offer.getIn(['_raw', 'maxDownloadDevices']) > 0 && offer.getIn(['_raw', 'maxDownloadDevices']) < filters.download) {
            return false;
          }
        }

        return true;
      });
  }

  getStreaming(value) {
    if (value) {
      const val = parseInt(value[0]);
      if (val == UNLIMITED_STREAMING || val === 0) {
        return 'Ubegrænset';
      }
      return `${val}+ Enheder`;
    }
    return '';
  }

  getDownload(value) {
    if (value) {
      const val = parseInt(value[0]);
      if (val == UNLIMITED_DOWNLOAD || val === 0) {
        return 'Ubegrænset';
      }
      return `${val}+ Enheder`;
    }
    return '';
  }

  render() {
    const { offers, filter, filters, showcases } = this.state;

    return (
      <Grid>
        <Cell size='3/12' portable='1/1'>
          <SearchPanel
            title={'Streaming'}
            filter={filter}
            results={offers}
            filterTexts={this.createSearchDisplay(filters)}
          >
            <SearchGroup>
              <Slider
                name='streaming'
                connect='lower'
                disconnected={filters.streaming === null}
                headline={['Streaming Enh.', this.getStreaming]}
                units={['Ubegrænset', '5+ | Ubegrænset']}
                min={0}
                max={5}
                range={{
                  min: [0, 1],
                  '20%': [1, 1],
                  '60%': [3, 1],
                  max: [UNLIMITED_STREAMING]
                }}
                defaultStart={[filters.streaming || UNLIMITED_STREAMING]}
                onSlide={this.sliderOnChange}
              />
              <Slider
                name='download'
                connect='lower'
                disconnected={filters.download === null}
                headline={['Download Enh.', this.getDownload]}
                units={['Ubegrænset', '5+ | Ubegrænset']}
                min={0}
                max={5}
                range={{
                  min: [0, 1],
                  '20%': [1, 1],
                  '60%': [3, 1],
                  max: [UNLIMITED_DOWNLOAD]
                }}
                defaultStart={[filters.download || UNLIMITED_DOWNLOAD]}
                onSlide={this.sliderOnChange}
              />
            </SearchGroup>
            <TagFilter
              headline={'Tags'}
              feed={this.state.feed}
              offerType={this.state.offerType}
              items={offers}
              filters={filters}
              checkboxOnChange={this.tagsOnChange}
            />
          </SearchPanel>
        </Cell>
        <Cell>
          <Showcase list={showcases} orderText='Bestil her' site_id={this.state.siteId} feed={this.state.feed} url={this.state.url} filters_used={this.state.filtersUsed}/>
          {this.renderResults(null, this.resetFilter.bind(this))}
        </Cell>
      </Grid>
    );
  }
}

export default Offers;
